import { render, staticRenderFns } from "./VSnake.vue?vue&type=template&id=50533d3c&"
import script from "./VSnake.vue?vue&type=script&lang=ts&"
export * from "./VSnake.vue?vue&type=script&lang=ts&"
import style0 from "./VSnake.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports